/**
 * Test IDs for QA automation.
 */
export const testIds = {
  assetTrackingMapToggleSummaryView: "asset-tracking-map-toggle-summary-view",
} as const;
